import { Injectable } from '@angular/core';
import { ImportCargoItem } from "../models/cargo-item.interface";
import { Stats } from "../models/stats.interface";
import { Container } from "../models/container.interface";
import { Customer } from '../models/customer-master.interface';

@Injectable({
  providedIn: 'root'
})
export class StatsService {

  constructor() { }

  createJobOrderStatsForTallyEditMode(selectedJobOrder: any) {
    console.log(selectedJobOrder)
    return [{
      displayLabel: "Job Order No.",
      value: selectedJobOrder?.jobOrderNo
    },
      {
        displayLabel: "Tally Type",
        value: selectedJobOrder?.tallyType
      },

    ];
  }

  createJobOrderStats(selectedJobOrder: any) {
    console.log("selectedJobOrder: ", selectedJobOrder)
    return [{
      displayLabel: "Job Order No.",
      value: selectedJobOrder?.jobOrderNo?.toString()
    },
      {
        displayLabel: "Job Order Type",
        value: selectedJobOrder?.jobOrderType.toString()
      },
      {
        displayLabel: "Issue Date",
        value: selectedJobOrder?.issueDate,
        dataType: "date",
        iconUrl: "assets/icons/calendar_icon.svg"
      },
      {
        displayLabel: "Validity Date",
        value: selectedJobOrder?.dueDate,
        dataType: "date"
      }

    ];
  }

    createInventoryDetailStatsForTally(cargoItem: ImportCargoItem): Stats[] {
    return [
      {
        displayLabel: "IGM Item No.",
        value: cargoItem?.igmItemNo?.toString(),
        iconUrl: "assets/icons/package_icon.svg"
      },
      {
        displayLabel: "BOE No.",
        value: cargoItem?.boeNo?.toString()
      },
      {
        displayLabel: "BL No.",
        value: cargoItem?.blNo?.toString()
      },
      {
        displayLabel: "Account Holder",
        value: cargoItem?.accountHolderName
      },
      {
        displayLabel: "Consignee",
        value: cargoItem?.consigneeName
      },
      {
        displayLabel: "NOP",
        value: cargoItem?.numberOfPackages?.toString()
      },
      {
        displayLabel: "Gross Weight",
        value: cargoItem?.grossWeight?.toString()
      }
    ];
  }

  createContainerStatsForTally(container: Container): Stats[] {
    return [
      {
        displayLabel: "Container No.",
        value: container?.containerNo?.toString()
      },
      {
        displayLabel: "Size",
        value: container.containerSize
      },
      {
        displayLabel: "Type",
        value: container?.containerType
      },
      {
        displayLabel: "ISO Code",
        value: container?.isoCode
      },
      {
        displayLabel: "Cargo Weight",
        value: container?.cargoWeight?.toString()
      },
      {
        displayLabel: "NOP",
        value: container?.totalPackages?.toString()
      },
      {
        displayLabel: "Line Seal No",
        value: container.lineSealNo
      }
    ];
  }

  createStatsForCustomerPDABalance(customer: Customer): Stats[] {
    return [
      {
        displayLabel: "Account Balance Overview",
        value: undefined,
      },
      {
        displayLabel: "PDA Amount",
        value: customer?.pdaAmount?.toString(),
      },
      {
        displayLabel: "Credit Balance",
        value: customer?.creditBalance?.toString(),
      },
    ];
  }
}
